import type { ExternalTableSchema } from '@packages/table-builder';

/**
 * Embedded source picker for the role-mapping compose modal.
 * Rows are prefetched by BUILD_ROLE_MAPPING_FORM; table runs in controlled `data` mode.
 */
const ROLE_MAPPING_SOURCE_PICKER_COLUMNS: ExternalTableSchema['columns'] = [
  {
    field: 'name',
    header: 'Source Company',
    type: 'text',
    sortable: false,
    width: 150,
  },
  {
    field: 'roleName',
    header: 'Published Role',
    type: 'text',
    sortable: false,
    width: 150,
  },
];

const ROLE_MAPPING_SOURCE_PICKER_FEATURES_BASE: ExternalTableSchema['features'] = {
  search: { enabled: false },
  pagination: { mode: 'none' },
  columnPreferences: {
    persistenceKey: 'RoleMappingModalSourcePicker',
    resizable: true,
    reorderable: true,
  },
};

/**
 * @param selectionEnabled — checkboxes for create/edit; view omits `features.selection`.
 */
export function roleMappingSourcePickerSchema(selectionEnabled: boolean): ExternalTableSchema {
  return {
    metadata: {
      title: '',
      entity: 'roleMappingModalSourcePicker',
    },
    dataSource: {
      endpoint: '/api/customer/api/customer/customer-success-options/role-mapping',
      method: 'GET',
      rowIdField: 'id',
    },
    columns: ROLE_MAPPING_SOURCE_PICKER_COLUMNS,
    features: {
      ...ROLE_MAPPING_SOURCE_PICKER_FEATURES_BASE,
      ...(selectionEnabled ? { selection: { keyField: 'id' } } : {}),
    },
  };
}
